import React, { useState, useEffect} from 'react';
import { Modal, Form, Button, Alert, Container} from 'react-bootstrap';

import hero1 from '../assets/images/hero-1.png';
import hero2 from '../assets/images/hero-2.png';
import hero3 from '../assets/images/hero-3.jpg';
import hero4 from '../assets/images/hero-4.jpg';
import productsData from '../data/productsData';
import panelImg from '../assets/images/productenclosure.png';
import busbarImg from '../assets/images/bushbar.png';
import protectionImg from '../assets/images/protection.png';
import wiringImg from '../assets/images/internalwiringdisc.png';
import testingImg from '../assets/images/testingandvalidation.png';
import isoLogo from '../assets/certifications/iso.png';
import msmeLogo from '../assets/certifications/msme.png';
import iecLogo from '../assets/certifications/iec.png';
import CEIGLogo from '../assets/certifications/CEIG.png';
import SGSLogo from '../assets/certifications/SGS.png';
import Grade_ALogo from '../assets/certifications/Grade_A.png';
import blueprintBg from '../assets/images/bluprint.jpg';

/* ================= AUTO IMPORT CLIENT LOGOS ================= */

/* ================= AUTO IMPORT CLIENT LOGOS ================= */

const importAll = (r) => r.keys().map(r);

const allClientLogos = importAll(
  require.context(
    "../assets/clients",
    false,
    /\.(png|jpe?g|svg|webp)$/i
  )
);


/* ================= SEPARATE INTERNATIONAL CLIENTS ================= */
/* Rule: filenames containing "-int" are international clients */

const internationalClients = allClientLogos.filter((logo) =>
  logo.includes("-int")
);

const regularClients = allClientLogos.filter(
  (logo) => !logo.includes("-int")
);

/* ================= SPLIT REGULAR CLIENTS INTO 3 ROWS ================= */

const splitIntoRows = (logos, rows = 3) => {
  const result = Array.from({ length: rows }, () => []);
  logos.forEach((logo, index) => {
    result[index % rows].push(logo);
  });
  return result;
};

/* IMPORTANT: split ONLY regular clients */
const [row1Logos, row2Logos, row3Logos] = splitIntoRows(regularClients, 3);




const Home = ({ setCurrentPage, setSelectedProduct }) => {
  const [active, setActive] = useState(0);

  /* ================= POPUP STATE ================= */

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const [leadData, setLeadData] = useState({
    name: "",
    phone: "",
    company: "",
    requirement: "",
    website: ""
  });

  /* ================= AUTO OPEN ================= */

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("leadPopupShown");

    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setShowModal(true);
        sessionStorage.setItem("leadPopupShown", "true");
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, []);

  /* ================= INPUT ================= */

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setLeadData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /* ================= SUBMIT ================= */

  const handleLeadSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;

  setLoading(true);
  setError("");

  const payload = {
    name: leadData.name,
    email: "noemail@lead.com",
    phone: leadData.phone,
    company: leadData.company,
    industry: "General",
    inquiryType: "Quick Inquiry",
    projectDetails: leadData.requirement,
    message: leadData.requirement,
    website: leadData.website || ""
  };

  try {
    const res = await fetch(
      "https://vigneshwarapowercontrols.in/api/send-lead.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }
    );

    const result = await res.json();

    if (result.success) {
      setSubmitted(true);
      setLeadData({
        name: "",
        phone: "",
        company: "",
        requirement: "",
        website: ""
      });

      setTimeout(() => {
        setShowModal(false);
        setSubmitted(false);
      }, 2500);
    } else {
      setError(result.message || "Submission failed");
    }

  } catch (err) {
    setError("Server error. Please try again.");
  }

  setLoading(false);
};



  const engineeringLifecycle = [
    {
      id: 1,
      title: 'Panel Enclosure Design',
      desc: 'Mechanical layout, thermal planning, ingress protection, and service accessibility engineered upfront.',
      img: panelImg,
    },
    {
      id: 2,
      title: 'Busbar & Power Architecture',
      desc: 'Optimized current paths, thermal efficiency, and fault-withstand capacity designed at system level.',
      img: busbarImg,
    },
    {
      id: 3,
      title: 'Protection & Control Logic',
      desc: 'Short-circuit, overload, and selectivity coordination engineered for safe fault isolation.',
      img: protectionImg,
    },
    {
      id: 4,
      title: 'Internal Wiring Discipline',
      desc: 'Structured wiring ensuring safety, traceability, and long-term scalability.',
      img: wiringImg,
    },
    {
      id: 5,
      title: 'Testing & Validation',
      desc: 'Routine, functional, insulation, and safety testing before commissioning.',
      img: testingImg,
    },
  ];



  const slides = [
    {
      title: 'Powering Industrial Excellence',
      subtitle: 'Electrical Panels • Automation • Control Systems',
      description:
        'We design and manufacture high-performance electrical panels and industrial power control systems built for reliability, safety, and long-term operation.',
      image: hero1
    },
    {
      title: 'Precision-Engineered Power Solutions',
      subtitle: 'Manufacturing with Engineering Integrity',
      description:
        'From LT & HT panels to MCCs and PCCs, our solutions are engineered with precision, compliance, and uncompromising quality standards.',
      image: hero2
    },
    {
      title: 'Testing, Commissioning & Reliability',
      subtitle: 'Built for Safety. Proven in Performance.',
      description:
        'Advanced testing, commissioning, and validation services ensuring electrical safety, system accuracy, and operational excellence.',
      image: hero3
    },
    {
      title: 'Smart Electrical & Automation Systems',
      subtitle: 'Future-Ready Industrial Infrastructure',
      description:
        'Intelligent automation and modern electrical systems designed to enhance efficiency, monitoring, and control across industries.',
      image: hero4
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);
   useEffect(() => {
  const counters = document.querySelectorAll('.impact-card h3');

  const runCounter = (counter) => {
    const target = +counter.getAttribute('data-target');
    let count = 0;
    const increment = Math.ceil(target / 120);

    const update = () => {
      count += increment;
      if (count >= target) {
        counter.innerText = target.toLocaleString() + '+';
      } else {
        counter.innerText = count.toLocaleString();
        requestAnimationFrame(update);
      }
    };

    update();
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          runCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((counter) => observer.observe(counter));
}, []);

  const styles = `
    /* ===== VPC BRAND COLORS ===== */
    :root {
      --vpc-blue: #0054A6;
      --vpc-red: #E42525;
      --vpc-yellow: #FFC020;
      --vpc-light-blue: #9BCCF8;
      --vpc-dark: #0a1a2d;
      --vpc-light: #f8f9fa;
    }
    
  .hero {
  height: 90vh;
}

    .hero-slide {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
  z-index: 1;
}

.hero-slide.active {
  opacity: 1;
}

    /* UPDATED OVERLAY LAYER with VPC Blue */
    .hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.45) 45%,
    rgba(0, 0, 0, 0.25) 100%
  );
  z-index: 2;
}


    /* TEXT LAYER */
    .hero-content {
      position: relative;
      z-index: 3;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .hero-box {
      max-width: 820px;
      color: #ffffff;
    }

    .hero-subtitle {
      text-transform: uppercase;
      letter-spacing: 2.5px;
      font-size: 0.95rem;
      font-weight: 600;
      color: var(--vpc-yellow);
      margin-bottom: 20px;
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }

    .hero-subtitle::before,
    .hero-subtitle::after {
      content: '';
      width: 30px;
      height: 2px;
      background: var(--vpc-yellow);
      opacity: 0.5;
    }

    .hero-title {
      font-size: 3.2rem;
      font-weight: 800;
      line-height: 1.1;
      margin-bottom: 25px;
      background: linear-gradient(180deg, #ffffff, var(--vpc-light-blue));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .hero-desc {
      color: rgba(255, 255, 255, 0.9);
      font-size: 1.15rem;
      line-height: 1.6;
      margin-bottom: 35px;
      max-width: 700px;
    }

    .hero-actions {
      display: flex;
      gap: 15px;
      margin-bottom: 30px;
    }

    .hero-btn-primary {
      background: linear-gradient(135deg, var(--vpc-blue), #003b7a);
      border: none;
      padding: 16px 35px;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 8px;
      box-shadow: 0 8px 25px rgba(0, 84, 166, 0.4);
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .hero-btn-primary:hover {
      transform: translateY(-3px);
      box-shadow: 0 12px 30px rgba(0, 84, 166, 0.6);
      background: linear-gradient(135deg, #0066cc, #004a99);
    }

    .hero-btn-outline {
      background: transparent;
      border: 2px solid var(--vpc-yellow);
      color: #fff;
      padding: 16px 35px;
      font-size: 1rem;
      font-weight: 600;
      border-radius: 8px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .hero-btn-outline:hover {
      background: var(--vpc-yellow);
      color: var(--vpc-dark);
      border-color: var(--vpc-yellow);
      transform: translateY(-3px);
    }

    /* ===================== UPDATED VALUE STRIP ===================== */
    .value-strip {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      width: 100%;
      background: var(--vpc-light);
      border-bottom: 4px solid var(--vpc-blue);
    }

    .value-card {
      padding: 40px 30px;
      text-align: left;
      position: relative;
      border-right: 1px solid rgba(0, 84, 166, 0.1);
      transition: all 0.3s ease;
    }

    .value-card:last-child {
      border-right: none;
    }

    .value-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0, 84, 166, 0.15);
    }

    .value-card h3 {
      font-size: 1.35rem;
      font-weight: 700;
      margin-bottom: 15px;
      line-height: 1.3;
    }

    .value-card p {
      font-size: 0.95rem;
      line-height: 1.5;
      color: #4b5563;
    }

    /* BLUE CARD - Updated to VPC Blue */
    .value-card.blue {
      background: var(--vpc-blue);
      color: #ffffff;
    }

    .value-card.blue h3 {
      color: #ffffff;
    }

    .value-card.blue p {
      color: rgba(255, 255, 255, 0.9);
    }

    /* WHITE CARD */
    .value-card.white {
      background: #f7f4f4e4;
      color: var(--vpc-blue);
    }

    .value-card.white h3 {
      color: var(--vpc-blue);
    }

    /* RED CARD - Updated to VPC Red */
    .value-card.red {
      background: var(--vpc-red);
      color: #ffffff;
    }

    .value-card.red h3 {
      color: #ffffff;
    }

    .value-card.red p {
      color: rgba(255, 255, 255, 0.9);
    }

    /* ICON */
    .value-icon {
      width: 56px;
      height: 56px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      font-size: 1.5rem;
    }

    .value-card.blue .value-icon {
      background: rgba(255, 255, 255, 0.2);
      color: var(--vpc-yellow);
    }

    .value-card.white .value-icon {
      background: var(--vpc-light-blue);
      color: var(--vpc-blue);
    }

    .value-card.red .value-icon {
      background: rgba(255, 255, 255, 0.2);
      color: #ffffff;
    }

    /* Indicator line */
    .value-card::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 30px;
      right: 30px;
      height: 3px;
      background: linear-gradient(90deg, var(--vpc-blue), var(--vpc-yellow));
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    .value-card:hover::after {
      transform: scaleX(1);
    }

    /* RESPONSIVE */
    @media (max-width: 1200px) {
      .hero-title {
        font-size: 2.8rem;
      }
      
      .hero-desc {
        font-size: 1.1rem;
      }
    }

    @media (max-width: 992px) {
      .hero {
        min-height: 600px;
      }
      
      .hero-title {
        font-size: 2.4rem;
      }
      
      .hero-desc {
        font-size: 1.05rem;
      }
      
      .value-strip {
        grid-template-columns: 1fr;
      }

      .value-card {
        padding: 35px 25px;
        border-right: none;
        border-bottom: 1px solid rgba(0, 84, 166, 0.1);
      }

      .value-card:last-child {
        border-bottom: none;
      }
    }

    @media (max-width: 768px) {
      .hero {
        min-height: 550px;
        height: 80vh;
      }
      
      .hero-title {
        font-size: 2rem;
      }
      
      .hero-desc {
        font-size: 1rem;
      }
      
      .hero-actions {
        flex-direction: column;
        align-items: flex-start;
      }
      
      .hero-btn-primary,
      .hero-btn-outline {
        width: 100%;
        max-width: 280px;
        justify-content: center;
      }
      
      .value-card {
        padding: 30px 20px;
      }
      
      .value-card h3 {
        font-size: 1.25rem;
      }
      
      .value-card p {
        font-size: 0.9rem;
      }
    }

    @media (max-width: 576px) {
      .hero {
        min-height: 500px;
      }
      
      .hero-title {
        font-size: 1.8rem;
      }
      
      .hero-subtitle {
        font-size: 0.85rem;
        letter-spacing: 2px;
      }
      
      .hero-desc {
        font-size: 0.95rem;
      }
      
      .hero-btn-primary,
      .hero-btn-outline {
        padding: 14px 25px;
        font-size: 0.95rem;
      }
    }
      /* ===================== WHO WE ARE SECTION ===================== */
.about-preview {
  position: relative;
  background: #ffffff;
  padding: 100px 0;
  overflow: hidden;
}

.about-preview::before {
  content: '';
  position: absolute;
  right: -100px;
  top: 0;
  width: 520px;          /* MORE WIDTH */
  height: 100%;
  background: var(--vpc-red);
  transform: skewX(-12deg);
  opacity: 0.14;         /* MORE VISIBILITY */
}
.about-badge {
  border: 5px solid var(--vpc-red);
  box-shadow:
    0 15px 40px rgba(0,0,0,0.15),
    0 0 0 6px rgba(228, 37, 37, 0.15); /* RED HALO */
}
.about-title {
  position: relative;
}

.about-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -12px;
  width: 90px;
  height: 4px;
  background: var(--vpc-red);
  border-radius: 2px;
}


.about-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 2;
}

.about-tag {
  color: var(--vpc-red);
  font-weight: 700;
  letter-spacing: 2px;
  font-size: 0.85rem;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.about-title {
  font-size: 2.6rem;
  font-weight: 800;
  color: var(--vpc-dark);
  line-height: 1.2;
  margin-bottom: 25px;
}

.about-text {
  font-size: 1.05rem;
  line-height: 1.75;
  color: #374151;
  max-width: 560px;
  margin-bottom: 35px;
}

.about-btn {
  background: var(--vpc-blue);
  color: #ffffff;
  padding: 14px 32px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.about-btn:hover {
  background: #004a99;
  transform: translateY(-2px);
}

/* IMAGE BLOCK */
.about-image-wrapper {
  position: relative;
}

.about-image-wrapper img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
}

/* EXPERIENCE BADGE */
.about-badge {
  position: absolute;
  top: -30px;
  right: -30px;
  background: #ffffff;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 5px solid var(--vpc-red);
}

.about-badge h4 {
  font-size: 2.2rem;
  color: var(--vpc-red);
  margin: 0;
  font-weight: 800;
}

.about-badge span {
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  text-align: center;
}

/* RESPONSIVE */
@media (max-width: 992px) {
  .about-grid {
    grid-template-columns: 1fr;
  }

  .about-badge {
    right: 20px;
    top: 20px;
  }
}

@media (max-width: 576px) {
  .about-title {
    font-size: 2rem;
  }

  .about-preview {
    padding: 70px 0;
  }
}
/* ===================== ABOUT PREVIEW ANIMATIONS ===================== */

/* Initial hidden state */
.about-preview.animate-hidden .about-tag,
.about-preview.animate-hidden .about-title,
.about-preview.animate-hidden .about-text,
.about-preview.animate-hidden .about-btn {
  opacity: 0;
  transform: translateX(-40px);
}

.about-preview.animate-hidden .about-image-wrapper {
  opacity: 0;
  transform: translateX(40px);
}

.about-preview.animate-hidden .about-badge {
  opacity: 0;
  transform: scale(0.7);
}

/* Animated visible state */
.about-preview.animate-show .about-tag,
.about-preview.animate-show .about-title,
.about-preview.animate-show .about-text,
.about-preview.animate-show .about-btn,
.about-preview.animate-show .about-image-wrapper,
.about-preview.animate-show .about-badge {
  opacity: 1;
  transform: none;
}

/* Smooth timing */
.about-tag {
  transition: all 0.6s ease 0.1s;
}

.about-title {
  transition: all 0.7s ease 0.2s;
}

.about-text {
  transition: all 0.8s ease 0.35s;
}

.about-btn {
  transition: all 0.8s ease 0.5s;
}

.about-image-wrapper {
  transition: all 0.9s ease 0.3s;
}

.about-badge {
  transition: all 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.6s;
}
/* ===================== IMPACT STATS ===================== */
.impact-stats {
  position: relative;
  padding: 110px 0;
  background: #ffffff;
  overflow: hidden;
}

/* ===================== IMPACT STATS SECTION ===================== */
.impact-stats {
  position: relative;
  padding: 110px 0;
  background: #ffffff;
  overflow: hidden;
}

/* ===================== CSS DOTTED WORLD MAP ===================== */
.impact-stats::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
  radial-gradient(circle, rgba(0, 2, 5, 0.97) 1.4px, transparent 1.5px);
  background-size: 28px 28px;
  opacity: 0.35;
  z-index: 1;
  animation: mapPulse 6s ease-in-out infinite;
}

/* SUBTLE ANIMATION */
@keyframes mapPulse {
  0% { opacity: 0.25; }
  50% { opacity: 0.45; }
  100% { opacity: 0.25; }
}

/* ENSURE CONTENT IS ABOVE BG */
.impact-header,
.impact-grid {
  position: relative;
  z-index: 2;
}

/* ===================== HEADER ===================== */
.impact-header {
  position: relative;
  z-index: 2;
  text-align: center;
  margin-bottom: 70px;
}

/* TOP TAG */
.impact-tag {
  display: block;
  font-size: 0.9rem;
  letter-spacing: 3px;
  font-weight: 700;
  color: var(--vpc-red);
  margin-bottom: 14px;
}

/* TITLE */
.impact-title {
  font-size: 2.6rem;
  font-weight: 800;
  color: var(--vpc-dark);
  margin: 0;
}

/* RED UNDERLINE */
.impact-underline {
  width: 90px;
  height: 4px;
  background: var(--vpc-red);
  border-radius: 3px;
  margin: 18px auto 24px;
}

/* DESCRIPTION */
.impact-desc {
  max-width: 720px;
  margin: 0 auto;
  font-size: 1.05rem;
  color: #4b5563;
  line-height: 1.7;
}

/* ===================== GRID ===================== */
.impact-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}

/* ===================== CARD ===================== */
.impact-card {
  text-align: center;
}

.impact-card h3 {
  font-size: 3.2rem;
  font-weight: 800;
  color: var(--vpc-red);
  margin-bottom: 8px;
}

.impact-card p {
  font-size: 1rem;
  font-weight: 600;
  color: var(--vpc-dark);
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 992px) {
  .impact-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 35px;
  }
}

@media (max-width: 576px) {
  .impact-title {
    font-size: 2rem;
  }

  .impact-card h3 {
    font-size: 2.6rem;
  }
}
  /* ================= CUSTOM CONSULTATION MODAL ================= */

.custom-consultation-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
}

/* Header */
.custom-consultation-modal .modal-header {
  background: #0f1f3a;
  color: #ffffff;
  border-bottom: none;
  padding: 20px 25px;
}

.custom-consultation-modal .modal-title {
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.5px;
}

/* Body */
.custom-consultation-modal .modal-body {
  padding: 30px 25px;
  background: #ffffff;
}

/* Labels */
.custom-consultation-modal .form-label {
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
}

/* Inputs */
.custom-consultation-modal .form-control {
  border-radius: 8px;
  padding: 10px 14px;
  border: 1px solid #ddd;
  transition: all 0.3s ease;
}

.custom-consultation-modal .form-control:focus {
  border-color: #d32f2f;
  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.15);
}

/* Submit Button */
.custom-consultation-modal button[type="submit"] {
  background: linear-gradient(135deg, #d32f2f, #b71c1c);
  border: none;
  padding: 12px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.custom-consultation-modal button[type="submit"]:hover {
  background: linear-gradient(135deg, #b71c1c, #d32f2f);
  transform: translateY(-1px);
}

/* Alerts */
.custom-consultation-modal .alert-success {
  background: #e8f5e9;
  color: #2e7d32;
  border: none;
  font-size: 14px;
}

.custom-consultation-modal .alert-danger {
  background: #ffebee;
  color: #c62828;
  border: none;
  font-size: 14px;
}

/* Close Button */
.custom-consultation-modal .btn-close {
  filter: invert(1);
}

/* ================= MOBILE RESPONSIVE ================= */

@media (max-width: 768px) {
  .custom-consultation-modal .modal-body {
    padding: 20px 18px;
  }

  .custom-consultation-modal .modal-title {
    font-size: 16px;
  }

  .custom-consultation-modal .form-control {
    font-size: 14px;
  }

  .custom-consultation-modal button[type="submit"] {
    padding: 10px;
    font-size: 14px;
  }
}
.modal-backdrop.show {
  backdrop-filter: blur(5px);
}


  `;
  const [aboutVisible, setAboutVisible] = useState(false);

useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setAboutVisible(true);
        observer.disconnect();
      }
    },
    { threshold: 0.25 }
  );
  

  const section = document.querySelector('.about-preview');
  if (section) observer.observe(section);

  return () => observer.disconnect();
}, []);


  return (
    <>
      <style>{styles}</style>

      {/* Hero Section */}
      <section className="hero">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`hero-slide ${i === activeIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}

        <div className="hero-overlay"></div>

        <Container className="hero-content">
          <div className="hero-box">
            <div className="hero-subtitle">
              {slides[activeIndex].subtitle}
            </div>
            
            <h1 className="hero-title">
              {slides[activeIndex].title}
            </h1>
            
            <p className="hero-desc">
              {slides[activeIndex].description}
            </p>

            
          </div>
        </Container>
      </section>

      {/* Updated Value Strip Section */}
      <section className="value-strip">
        <div className="value-card blue">
          <div className="value-icon">
            <i className="fas fa-layer-group"></i>
          </div>
          <h3>Engineered-to-Order Solutions</h3>
          <p>
            Custom-built electrical panels and automation systems designed to meet
            exact technical, safety, and operational requirements of each project.
          </p>
        </div>

        <div className="value-card white">
          <div className="value-icon">
            <i className="fas fa-industry"></i>
          </div>
          <h3>Multi-Sector Engineering Expertise</h3>
          <p>
            Proven experience across power, water, infrastructure, manufacturing,
            and industrial automation with deep domain understanding.
          </p>
        </div>

        <div className="value-card red">
          <div className="value-icon">
            <i className="fas fa-award"></i>
          </div>
          <h3>Quality, Testing & Compliance</h3>
          <p>
            Every panel undergoes rigorous testing and inspection to ensure safety,
            reliability, and compliance with industry standards.
          </p>
        </div>
      </section>
      {/* ===================== ABOUT PREVIEW SECTION ===================== */}
<section
  className={`about-preview ${
    aboutVisible ? 'animate-show' : 'animate-hidden'
  }`}
>

  <Container>
    <div className="about-grid">
      
      {/* LEFT CONTENT */}
      <div>
        <div className="about-tag">Who We Are</div>
        <h2 className="about-title">
          Engineering Reliable Power<br />for Modern Industries
        </h2>

        <p className="about-text">
          Vigneshwara Power Controls is a professionally managed electrical
          engineering company specializing in the design, manufacturing, and
          implementation of industrial electrical panels and automation systems.
          Our solutions support power, infrastructure, water, and manufacturing
          sectors with a strong focus on safety, reliability, and long-term
          performance.
        </p>

        <Button
  className="about-btn"
  onClick={() => window.open("https://vigneshwarapowercontrols.in", "_blank")}
>
  Visit Our Main Website
  <i className="fas fa-arrow-right"></i>
</Button>
      </div>

      {/* RIGHT IMAGE */}
      <div className="about-image-wrapper">
        <img src={hero2} alt="Industrial Electrical Engineering" />

        <div className="about-badge">
          <h4>25+</h4>
          <span>Years of<br />Experience</span>
        </div>
      </div>

    </div>
  </Container>
</section>

<section className="clients-marquee">

  {/* SECTION TITLE */}
  <div className="clients-title">
    <span className="clients-eyebrow">TRUSTED BY INDUSTRY</span>
    <h2 className="clients-heading">
      Our Clients
      <span className="heading-underline"></span>
    </h2>
  </div>


  {/* ================= REGULAR CLIENT ROW 1 ================= */}
  <div className="marquee-row">
    <div className="marquee-track">
      {row1Logos.concat(row1Logos).map((logo, i) => (
        <div className="logo-box" key={`r1-${i}`}>
          <img src={logo} alt="Client Logo" />
        </div>
      ))}
    </div>
  </div>

  {/* ================= REGULAR CLIENT ROW 2 ================= */}
  <div className="marquee-row reverse">
    <div className="marquee-track">
      {row2Logos.concat(row2Logos).map((logo, i) => (
        <div className="logo-box" key={`r2-${i}`}>
          <img src={logo} alt="Client Logo" />
        </div>
      ))}
    </div>
  </div>

  {/* ================= REGULAR CLIENT ROW 3 ================= */}
  <div className="marquee-row slow">
    <div className="marquee-track">
      {row3Logos.concat(row3Logos).map((logo, i) => (
        <div className="logo-box" key={`r3-${i}`}>
          <img src={logo} alt="Client Logo" />
        </div>
      ))}
    </div>
  </div>

  {/* ================= INTERNATIONAL CLIENTS ================= */}
{internationalClients.length > 0 && (
  <section className="international-clients">

    <div className="international-header">
      <span>GLOBAL PRESENCE</span>
      <h3>International Clients</h3>
      <p>
        Trusted by international partners for reliable and compliant
        power control solutions across borders.
      </p>
    </div>

    <div className="international-grid">
      {internationalClients.map((logo, index) => (
        <div className="international-logo-box" key={`int-${index}`}>
          <img src={logo} alt="International Client" />
        </div>
      ))}
    </div>

  </section>
)}


</section>


  
  {/* ===================== ENGINEERING PROOF SNAPSHOT ===================== */}
<section className="engineering-proof">
  <Container>
    <div className="engineering-proof-inner">
      
      <div className="engineering-proof-text">
        <span className="proof-eyebrow">ENGINEERING PROOF</span>
        <h3 className="proof-title">
          Certified. Audited. Trusted.
        </h3>
        <p className="proof-desc">
          Our engineering processes align with internationally recognized
          standards and verified industry compliance.
        </p>
      </div>

      <div className="proof-logos">
        {[
          { img: isoLogo, label: 'ISO 9001:2015' },
          { img: msmeLogo, label: 'MSME Registered' },
          { img: iecLogo, label: 'IEC Standards' },
          { img: CEIGLogo, label: 'CEIG Member' },
          { img: Grade_ALogo, label: ' A Grade  '},
          { img: SGSLogo, label: 'SGS Audited'}
        ].map((item, i) => (
          <div className="proof-logo-item" key={i}>
            <img src={item.img} alt={item.label} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>

    </div>
  </Container>
</section>
<Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  backdrop="static"
  dialogClassName="custom-consultation-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>
      Request Engineering Consultation
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>

    {/* SUCCESS MESSAGE */}
    {submitted && (
      <Alert variant="success">
        Thank you! Our team will contact you shortly.
      </Alert>
    )}

    {/* ERROR MESSAGE */}
    {error && (
      <Alert variant="danger">
        {error}
      </Alert>
    )}

    <Form onSubmit={handleLeadSubmit}>

      {/* Honeypot Field (Anti-Spam) */}
      <input
        type="text"
        name="website"
        value={leadData.website}
        onChange={handleLeadChange}
        style={{ position: "absolute", left: "-5000px" }}
        autoComplete="off"
      />

      {/* Full Name */}
      <Form.Group className="mb-3">
        <Form.Label>Full Name *</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={leadData.name}
          onChange={handleLeadChange}
          placeholder="Enter your full name"
          required
        />
      </Form.Group>

      {/* Phone */}
      <Form.Group className="mb-3">
        <Form.Label>Phone Number *</Form.Label>
        <Form.Control
          type="tel"
          name="phone"
          value={leadData.phone}
          onChange={handleLeadChange}
          placeholder="Enter your contact number"
          required
        />
      </Form.Group>

      {/* Company */}
      <Form.Group className="mb-3">
        <Form.Label>Company *</Form.Label>
        <Form.Control
          type="text"
          name="company"
          value={leadData.company}
          onChange={handleLeadChange}
          placeholder="Enter your company name"
          required
        />
      </Form.Group>

      {/* Requirement */}
      <Form.Group className="mb-4">
        <Form.Label>Requirement</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="requirement"
          value={leadData.requirement}
          onChange={handleLeadChange}
          placeholder="Briefly describe your requirement..."
        />
      </Form.Group>

      {/* Submit Button */}
      <Button
        type="submit"
        className="w-100"
        disabled={loading}
      >
        {loading ? "Submitting..." : "Submit Inquiry"}
      </Button>

    </Form>

  </Modal.Body>
</Modal>



    </>
  );
};

export default Home;